import { SurveyWidget, ISurveyWidgetProps } from '@cian/commercial-survey-widget';
import { ModalWindow } from '@cian/ui-kit';
import * as React from 'react';

import * as styles from './index.css';

export interface ISurveyWidgetModalProps extends ISurveyWidgetProps {
  isOpen: boolean;
  onSOPREvent?(action: string, label: string): void;
}

export const SurveyWidgetModal: React.SFC<ISurveyWidgetModalProps> = ({ isOpen, ...props }) => {
  return (
    <ModalWindow
      fixed
      open={isOpen}
      outside={false}
      escape={false}
      content={
        <div className={styles['body']}>
          <SurveyWidget {...props} />
        </div>
      }
    />
  );
};

SurveyWidgetModal.displayName = 'SurveyWidgetModal';
